// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3) return "client/js/3.js";
	if (chunkId === 466) return "client/js/466.js";
	if (chunkId === 842) return "client/js/842.js";
	if (chunkId === 780) return "client/js/780.js";
	if (chunkId === 34) return "client/js/34.js";
	if (chunkId === 792) return "client/js/792.js";
	if (chunkId === 520) return "client/js/520.js";
	// return url for filenames based on template
	return undefined;
};